/**
 * Сериализовать параметры фильтров в строку запроса.
 * @param {URLSearchParams|Record<string, string|string[]>} params
 * @returns {string}
 */
export const serializeFiltersToQuery = params => {
    if (params instanceof URLSearchParams) {
        return params.toString();
    }

    const searchParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(item => item && searchParams.append(key, item));
        } else if (value !== null && typeof value !== 'undefined' && value !== '') {
            searchParams.append(key, value);
        }
    });

    return searchParams.toString();
};
